module.exports = __webpack_public_path__ + "img/pic_rorate2.5f452964.png";